import { Model } from '@models'
import { initCalendar, processDateRangePayload, validateDateRange } from '@src/models/helper'
import reducers from './allEvents.reducers'

export default class AllEvents {
  namespace = 'allEvents'

  state = {
    ...Model.defaultState,
    calendar: initCalendar(),
  }

  effects = {
    changeDateRange: Model.buildEffect({
      name: `${this.namespace}/changeDateRange`,
      validation: validateDateRange,
      reducers: [
        {
          name: 'updateCalendarState',
          payload: processDateRangePayload,
        },
      ],
    }),
  }

  reducers = reducers
}
